import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

// AsyncThunk to fetch inventory list
export const get_inventory_list = createAsyncThunk(
  "inventory/getInventoryList",
  async (data, thunkAPI) => {
    try {
      const body = new FormData();
      body.append("userid", "1");
      body.append("ingress", "1");
      body.append("action", "list");
      body.append("page", data.page.toString());
      body.append("limit", data.rows.toString());

      const response = await fetch(`${baseUrl}inventory.php`, {
        method: "POST",
        body,
      });

      const res = await response.json();
      console.log("res", res);

      return res;
    } catch (error) {
      return thunkAPI.rejectWithValue("Failed to fetch inventory list.");
    }
  }
);
export const get_all_inventory_list = createAsyncThunk(
  "all_inventory/getInventoryList",
  async (data, thunkAPI) => {
    try {
      const body = new FormData();
      body.append("userid", "1");
      body.append("ingress", "1");
      body.append("action", "list");
      body.append("page", 1);
      body.append("limit", 1000);

      const response = await fetch(`${baseUrl}inventory.php`, {
        method: "POST",
        body,
      });

      const res = await response.json();
      console.log("res", res);

      return res;
    } catch (error) {
      return thunkAPI.rejectWithValue("Failed to fetch inventory list.");
    }
  }
);
//https:gaswala.vensframe.com/api/admin/reports/ledger_report.php
export const get_report_list = createAsyncThunk(
  "reports/getReportList",
  async (data, thunkAPI) => {
    try {
      const body = new FormData();

      body.append("action", data?.action);
      body.append("page", data?.page);
      body.append("limit", data?.limit);
      body.append("fd", "2025-06-20");
      // body.append("fd", data?.sd);
      body.append("td", "2025-06-30");
      // body.append("td", data?.ed);
      // body.append("prod_code", data?.pcode);
      body.append("prod_code", "PCI019");

      const response = await fetch(`${baseUrl}reports/ledger_report.php`, {
        method: "POST",
        body,
      });

      const res = await response.json();
      console.log("res", res);

      return res;
    } catch (error) {
      return thunkAPI.rejectWithValue("Failed to fetch inventory list.");
    }
  }
);

// Initial state
const initialState = {
  inventory_list: [],
  all_inventory_list: [],
  loading: false,
  all_loading: false,
  total_inventory_count: 0,
  report_data: {},
  report_loading: false,
};

// Slice
const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_inventory_list.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(get_inventory_list.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(get_inventory_list.fulfilled, (state, action) => {
      state.loading = false;
      const data = action.payload;
      console.log("inventory here");

      state.loading = false;
      if (data.success) {
        state.total_inventory_count = data.totalcount;
        state.inventory_list = data.data;
      } else {
        state.inventory_list = [];
      }
    });

    builder.addCase(get_all_inventory_list.pending, (state, action) => {
      state.all_loading = true;
    });
    builder.addCase(get_all_inventory_list.rejected, (state, action) => {
      state.all_loading = false;
    });
    builder.addCase(get_all_inventory_list.fulfilled, (state, action) => {
      state.all_loading = false;
      const data = action.payload;
      console.log("inventory here");

      state.all_loading = false;
      if (data.success) {
        state.all_inventory_list = data.data;
      } else {
        state.all_inventory_list = [];
      }
    });

    builder.addCase(get_report_list.pending, (state, action) => {
      state.report_loading = true;
    });
    builder.addCase(get_report_list.rejected, (state, action) => {
      state.report_loading = false;
    });
    builder.addCase(get_report_list.fulfilled, (state, action) => {
      state.report_loading = false;
      const data = action.payload;
      console.log("report here", data);

      state.report_loading = false;
      if (data.success) {
        state.report_data = data;
      } else {
        state.report_data = {};
      }
    });
  },
});

export default inventorySlice.reducer;
